/**
 * Finds annotations with a `start` property equal to a particular node identifier.
 *
 * @param {Array<object>} annotations
 * @param {string} identifier
 * @returns {Array<object>}
 */
const getAnnotationsStartingRelativeToNodeIdentifier = (
  annotations,
  identifier,
) => annotations.filter(({ start }) => start === identifier);

export default getAnnotationsStartingRelativeToNodeIdentifier;
